import { lazy, Suspense } from 'react';
import type { PostLocationPickerProps } from './PostLocationPickerImpl';

/**
 * Sprint BD (2026-05-20, R-5.1.6): PostLocationPicker を React.lazy wrapper に置換。
 * 実装本体 (`PostLocationPickerImpl.tsx`) は maplibre-gl を直接 import するため、
 * PostForm 到達時のみ chunk が dynamic load される (MapView と同じ chunk へ統合 —
 * vite.config.ts manualChunks 'maplibre-vendor' に集約)。
 *
 * 互換: public API (`PostLocationPickerProps`) 維持、caller (PostForm) 変更不要。
 */

export type { PostLocationPickerProps } from './PostLocationPickerImpl';

const LazyPostLocationPicker = lazy(() => import('./PostLocationPickerImpl'));

function PickerFallback({ className = 'h-56' }: { className?: string }) {
  return (
    <div
      className={`w-full ${className} rounded-lg overflow-hidden border border-slate-200 bg-slate-100 flex items-center justify-center`}
      aria-label="地図を読み込み中"
    >
      <div
        className="w-6 h-6 border-2 border-slate-300 border-t-primary-600 rounded-full animate-spin"
        role="status"
      />
    </div>
  );
}

export function PostLocationPicker(props: PostLocationPickerProps) {
  return (
    <Suspense fallback={<PickerFallback className={props.className} />}>
      <LazyPostLocationPicker {...props} />
    </Suspense>
  );
}
